import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["countdown"]
  static values = { redirectUrl: String, seconds: { type: Number, default: 5 } }

  connect() {
    this.remaining = this.secondsValue
    this.render()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  tick() {
    this.remaining -= 1
    this.render()
    if (this.remaining <= 0) {
      clearInterval(this.timer)
      window.location.href = this.redirectUrlValue
    }
  }

  render() {
    if (this.hasCountdownTarget) this.countdownTarget.textContent = this.remaining
  }
}
